import { Audio, Buttons, Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import InstructionsScreen from './InstructionsScreen';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroSceen'; }

  create() {
    Images.addImage(0, 0, 'yellow_background', this).setOrigin(0);

    const width = this.scale.width;
    const height = this.scale.height;

    const particleFrames = [
      'Circle1', 'Circle2', 'Circle3', 'Circle4',
    ];

    this.emitters = [];

    const circleStyles = [
      { color: 0xffffff, alpha: .7 },
      { color: 0x4b745b, alpha: 1 },
      { color: 0x769167, alpha: 1 },
      { color: 0x768c3d, alpha: 1 }];

    const graphics = this.make.graphics();
    graphics.fillStyle(circleStyles[0].color, circleStyles[0].alpha);
    graphics.fillCircle(5, 5, 5);
    graphics.generateTexture(particleFrames[0], 10, 10);
    const particleManager = this.add.particles(particleFrames[0]);
    this.emitter = particleManager.createEmitter({
      x: 200,
      y: 300,
      on: false,
      lifespan: 2000,
      speed: { min: 100, max: 300 },
      tint: [0x768c3d, 0x769167, 0x4b745b, 0xffffff]
    });

    const tile3 = Images.addImage(width / 2, 350, '3_tile', this);
    const tile5 = Images.addImage(width / 2, 350, '5_tile', this);
    const tile7 = Images.addImage(width / 2, 350, '7_tile', this);
    const tile5b = Images.addImage(-1 * width / 2, 350, '5_tile', this);
    const tile10 = Images.addImage(width / 2 + 150, height / 2, '10_tile', this);
    const tileLink = Images.addImage(230, 525, 'tile_link', this);
    const button = Buttons.addButton(width / 2, height / 2 + 300, 'go_button', 'go_button', null, null, this);
    const title = Images.addImage(width / 2, 350, 'title', this);

    this.animateTile({ tile: tile3, x: 200, y: 160, delay: 10, angle: 360, startScale: .5 });
    this.animateTile({ tile: tile5, x: 70, y: -160, delay: 200, angle: 360, startScale: .5 });
    this.animateTile({ tile: tile7, x: -70, y: -150, delay: 300, angle: -360, startScale: .5 });
    this.animateTile({ tile: tile5b, x: 563, y: 158, delay: 300, angle: 360, startScale: .5 });
    this.animateTile({ tile: tile10, x: -250, y: 30, delay: 400, angle: -360, startScale: .1 });

    Tweens.addTween(tileLink, 1300, { alpha: { start: 0, to: 1 }, delay: 1300 }, Phaser.Math.Easing.Quadratic.Out);

    Tweens.addTween(button, 800, { delay: 800, scale: { start: 0, to: .85 } }, Phaser.Math.Easing.Quadratic.Out, () => {
      Tweens.addTween(button, 150, { angle: -25 }, Phaser.Math.Easing.Quadratic.Out, () => {
        Tweens.addTween(button, 150, { angle: 25, yoyo: true }, Phaser.Math.Easing.Quadratic.Out, () => {
          Tweens.addTween(button, 150, { angle: 25, yoyo: true }, Phaser.Math.Easing.Quadratic.Out, () => {
            Tweens.addTween(button, 150, { angle: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
              // emit
              this.emitter.emitParticleAt(button.x, button.y, 10);
              button.on('pointerdown', () => {
                Audio.playOneShot('click', this);
                this.theme.stop();
                this.scene.start(InstructionsScreen.KEY);
              });
            });
          });
        });
      });
    });

    Tweens.addTween(title, 1000, { scale: { start: 0, to: 1 } }, Phaser.Math.Easing.Quadratic.Out, () => {
      Tweens.addTween(title, 300, { scaleX: 0.7 }, Phaser.Math.Easing.Quadratic.Out, () => {
        Tweens.addTween(title, 300, { scaleX: 1, scaleY: .7 }, Phaser.Math.Easing.Quadratic.Out, () => {
          Tweens.addTween(title, 300, { scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out);
        });
      });
    });

    this.theme = Audio.createSound(this);
    this.theme.play('clear_it_theme_music');
  };

  /**
   * 
   * @param {object} tileParams - need tile, tweenX, tweenY, delay, angle
   * @param {Phaser.GameObjects.Image} tileParams.tile - tile
   * @param {number} tileParams.x - value to add to x
   * @param {number} tileParams.y - value to add to x
   * @param {number} tileParams.delay - tween delay
   * @param {number} tileParams.angle - -360 or 360
   * @param {number} tileParams.startScale - start scale
   * @returns 
   */
  animateTile(tileParams) {

    const tile = tileParams.tile;
    const tweenX = tileParams.x;
    const tweenY = tileParams.y;
    const delay = tileParams.delay;
    const angle = tileParams.angle;
    const startScale = tileParams.scale;

    const tween = Tweens.addTween(
      tile,
      1000,
      { scale: { start: startScale, to: 0.85 },
        x: tile.x + tweenX,
        y: tile.y + tweenY,
        delay,
        angle: angle * 2 },
      Phaser.Math.Easing.Quadratic.Out,
      () => {this.emitter.emitParticleAt(tile.x, tile.y, 10);}
    );

    return tween;
  };
}